import { useLayoutEffect, useState } from "react";

import { getAccessStatus, useUserDataStore } from "@/stores/useUserDataStore";

import {
  USER_PERMISSIONS,
  USER_ROLES_RAW_DATA
} from "../../../roles/types/enums";

const useTableInlineActions = (
  initialActions: any[],
  permissionName: USER_PERMISSIONS,
  userRole?: USER_ROLES_RAW_DATA,
  exceptionalActions?: any,
  otherExceptions?: boolean
) => {
  const user = useUserDataStore(state => state.userData);
  const allowedToManageData = getAccessStatus(permissionName);

  const [tableInlineActions, setTableInlineActions] =
    useState<any>(initialActions);

  const isUserRoleCorrect = user?.role === userRole;

  useLayoutEffect(() => {
    if (allowedToManageData || otherExceptions) {
      setTableInlineActions(initialActions);
    } else if (isUserRoleCorrect) {
      setTableInlineActions(exceptionalActions);
    } else {
      setTableInlineActions([]);
    }
  }, [user]);

  return { tableInlineActions, allowedToManageData };
};

export default useTableInlineActions;
